import DashboardLayout from '../layouts/DashboardLayout'

export const promotionManagement = {
  path: '',
  component: DashboardLayout,
  name: 'Promotion',
  redirect: '/promotion',
  children: [
    {
      path: '/promotion',
      name: 'Promotion',
      component: () => import (/* webpackChunkName: "Promotion" */'../pages/promotion-management/index.vue'),
      meta: {
        roles: 'all',
        requiresAuth: true,
        breadcrumb: [{
          title: '',
        }],
        title: 'OMS Promotion List',
      },
    },
    {
      path: '/promotion/create',
      name: 'CreatePromotion',
      component: () => import (/* webpackChunkName: "promotion" */'../pages/promotion-management/create.vue'),
      meta: {
        roles: 'all',
        requiresAuth: true,
        breadcrumb: [{
          title: '',
        }],
        title: 'OMS New Promotion',
      },
    },
    {
      path: '/promotion/detail/:id',
      name: 'DetailPromotion',
      component: () => import (/* webpackChunkName: "Promotion" */'../pages/promotion-management/detail.vue'),
      meta: {
        roles: 'all',
        requiresAuth: true,
        breadcrumb: [{
          title: '',
        }]
      },
    },
  ],
}
